import { withRouter } from 'react-router-dom';

import Profile from '../components/Profile/Profile'

import { connect } from 'react-redux'
import { history } from './../util/Store'

import {
  createAccount,
  setAccountUUID,
  setToken,
  resetSession
} from '../actions/session';

import {
  resetConsole
} from '../actions/console';

function mapStateToProps(state) {
  return {
    console: state.console,
    session: state.session,
    token: state.session.token
  };
}

const mapDispatchToProps = {
  resetSession,
  resetConsole,
  createAccount,
  setAccountUUID,
  setToken,
  history
}

const ProfileHoc = connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);

export default withRouter(ProfileHoc)
